// This is a modal for Myreferralsfour

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckBoxComponent from "./CheckBox";
import GenericModal from "./GenericModal";
import ModalMyreferralsthree from "./ModalMyreferralsthree";
import { createDisputeItem } from "./redux/slices/DisputesThunks";
import { uploadImage } from "./redux/slices/VendorThunks";
import { formatDate } from "./utils/func";

export default function ModalMyreferralsfour({ onClose, referralSummary }) {
  const dispatch = useDispatch();
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [checked, setchecked] = useState(false);
  const member = JSON.parse(localStorage.getItem("member"));
  const existingDisputes = useSelector((state) => state.disputes.items);
  const [submitted, setSubmitted] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const [hasDispute, sethasDispute] = useState(false);
  const [checkError, setcheckError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fileError, setfileError] = useState("");

  // Allowed file types with their MIME types
  const allowedFileTypes = {
    "application/pdf": [".pdf"],
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
      ".docx",
    ],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/gif": [".gif"],
  };

  const validateFile = (file) => {
    if (!file) return { valid: true };

    // Check file size (5MB max)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      return {
        valid: false,
        error: "File must be less than 5MB",
      };
    }

    // Check file type by MIME type
    const isValidMimeType = Object.keys(allowedFileTypes).includes(file.type);

    // Also check by extension as fallback
    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.substring(fileName.lastIndexOf("."));
    const isValidExtension = Object.values(allowedFileTypes)
      .flat()
      .includes(fileExtension);

    if (!isValidMimeType && !isValidExtension) {
      return {
        valid: false,
        error:
          "Invalid file type. Please upload PDF, DOC, DOCX, JPG, PNG, or GIF files only.",
      };
    }

    return { valid: true };
  };

  const handleFieldChange = async (key, value) => {
    setfileError("");

    if (!value) {
      setFile(null);
      return;
    }

    // Validate file
    const validation = validateFile(value);
    if (!validation.valid) {
      setfileError(validation.error);
      setFile(null);
      return;
    }

    try {
      const res = await dispatch(uploadImage(value));

      if (res.payload && res.payload.fileURL) {
        setFile(res.payload.fileURL);
      } else {
        setfileError("File upload failed. Please try again.");
        setFile(null);
      }
    } catch (e) {
      console.error("File upload error:", e);
      setfileError("File upload failed. Please try again.");
      setFile(null);
    }
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    setIsSubmitting(true);
    setcheckError("");

    if (!subject || !description) {
      setIsSubmitting(false);
      return;
    }
    if (!checked) {
      setIsSubmitting(false);
      setcheckError("Confirm that the information provided is accurate");
      return;
    }
    const hasDispute =
      Array.isArray(existingDisputes) &&
      existingDisputes.some((item) => {
        return (
          item.referral_id === referralSummary?._id &&
          item.member_id === member?._id
        );
      });

    if (hasDispute) {
      sethasDispute(true);
      setsuccessModal(true);
      setIsSubmitting(false);
      return;
    }

    // Prepare dispute data
    const disputeData = {
      subject,
      explanation: description,
      referral_id: referralSummary?._id,
      member_id: member?._id,
      dispute_status: "Open",
      supporting_document: file || null, // Include null if no file
      date_raised: new Date().toISOString(),
    };

    try {
      await dispatch(createDisputeItem(disputeData));
      setsuccessModal(true);
      setIsSubmitting(false);
      setSubmitted(false);
    } catch (error) {
      console.error("Dispute submission failed", error);
      setIsSubmitting(false);
      // Optionally show error to user
      setfileError("Submission failed. Please try again.");
    }
  };

  return (
    <>
      {!successModal && (
        <RootWrapperModalMyreferralsfour>
          <Overlay>
            <Wrapper>
              <Dispute>
                <Frame1504>
                  <Frame1504>
                    <OpenADispute>Open a dispute</OpenADispute>
                    <IfYouBelieveTheStatusOfYourReferralIsNotUpToDateOrInaccurateYouCanOpenADisputeOurTeamWillReviewAndGetBackToYouAsSoonAsPossible>
                      If you believe the status of your referral is not
                      up-to-date or inaccurate, you can open a dispute. Our team
                      will review and get back to you as soon as possible.
                    </IfYouBelieveTheStatusOfYourReferralIsNotUpToDateOrInaccurateYouCanOpenADisputeOurTeamWillReviewAndGetBackToYouAsSoonAsPossible>
                  </Frame1504>
                  <Frame1422>
                    <Frame1505>
                      <Frame1429>
                        <ReferralSummary>Referral Summary</ReferralSummary>
                      </Frame1429>
                      <Frame1429 />
                    </Frame1505>

                    <Frame1511>
                      <Frame1510>
                        <Frame1429_0001>
                          <ReferralUrl>Referral NO.</ReferralUrl>
                        </Frame1429_0001>
                        <Frame1429>
                          <JohnDoe>{"R" + referralSummary._id.slice(-6)}</JohnDoe>
                        </Frame1429>
                      </Frame1510>
                      <Frame1510>
                        <Frame1429_0001>
                          <Vendor>Vendor:</Vendor>
                        </Frame1429_0001>
                        <Frame1429>
                          <XyzBusiness>
                            {referralSummary?.vendor_id?.company_name}
                          </XyzBusiness>
                        </Frame1429>
                      </Frame1510>
                    </Frame1511>
                    <Frame1511>
                      <Frame1510>
                        <Frame1429_0001>
                          <ReferralUrl>Referral URL:</ReferralUrl>
                        </Frame1429_0001>
                        <Frame1429>
                          <JohnDoe>
                            {referralSummary?.company_website_url}
                          </JohnDoe>
                        </Frame1429>
                      </Frame1510>
                      <Frame1510>
                        <Frame1429_0001>
                          <RejectionReason>Rejection Date:</RejectionReason>
                        </Frame1429_0001>
                        <Frame1429>
                          <_4Apr2025> {referralSummary?.created_at
                            ? formatDate(referralSummary?.created_at)
                            : ""}</_4Apr2025>
                        </Frame1429>
                      </Frame1510>
                    </Frame1511>
                    <Frame1511>
                      <Frame1510>
                        <Frame1429_0001>
                          <SubmittedTo>Submitted To:</SubmittedTo>
                        </Frame1429_0001>
                        <Frame1429>
                          <_1Apr2025>{referralSummary?.submitted_to}</_1Apr2025>
                        </Frame1429>
                      </Frame1510>
                    </Frame1511>
                    <Frame1509>
                      <Frame1429_0001>
                        <RejectionReason>Rejection Reason:</RejectionReason>
                      </Frame1429_0001>
                      <Frame1429>
                        <UnfortunatelyYourReferralWasNotSuccessfulThisTime>
                          {referralSummary?.referral_lost_reason}
                        </UnfortunatelyYourReferralWasNotSuccessfulThisTime>
                      </Frame1429>
                    </Frame1509>
                  </Frame1422>
                </Frame1504>
                <Frame1514>
                  <PRTNR.Input
                    label="Subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    error={submitted && !subject}
                    errorMessage={"Subject can not be empty"}
                    required
                  />
                  <PRTNR.TextArea
                    label={
                      "Please detail why you would like to dispute the outcome of this specific referral"
                    }
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    error={submitted && !description}
                    errorMessage={"Required"}
                    required
                  />

                  <PRTNR.FileInput
                    label="Attach Supporting Document"
                    helpText="Supported file types: PDF, DOC, DOCX, JPG, PNG, or GIF. Maximum size: 5MB."
                    accept=".jpg,.jpeg,.gif,.png,.doc,.docx,.pdf"
                    onChange={(e) => {
                      if (e) {
                        handleFieldChange("supporting_document", e);
                      }
                    }}
                  />
                  {fileError && <ErrorMessage>{fileError}</ErrorMessage>}

                  <Frame1412>
                    <CheckBoxComponent
                      label={
                        <>
                          I confirm that the information provided is accurate to
                          the best of my knowledge.{" "}
                          <span style={{ color: "red" }}>*</span>
                        </>
                      }
                      checked={checked}
                      onChange={(e) => setchecked(e.target.checked)}
                    />
                    {checkError && <ErrorMessage>{checkError}</ErrorMessage>}
                  </Frame1412>
                </Frame1514>
                <Frame59>
                  <AIMEButton
                    size="small"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      width: "100%",
                      maxWidth: "320px",
                      background: "rgb(33, 37, 67)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                      "&:hover": {
                        background: "rgb(33, 37, 67)",
                        opacity: "0.9",
                      },
                      "&:disabled": {
                        opacity: "0.6",
                        cursor: "not-allowed",
                      },
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      {isSubmitting ? "Submitting..." : "Submit Dispute"}
                    </span>
                  </AIMEButton>
                </Frame59>
              </Dispute>
            </Wrapper>
          </Overlay>
        </RootWrapperModalMyreferralsfour>
      )}
      {successModal && (
        <GenericModal
          isOpen={successModal}
          onClose={() => setsuccessModal(!successModal)}
        >
          <ModalMyreferralsthree
            isOpen={successModal}
            onClose={() => setsuccessModal(!successModal)}
            hasDispute={hasDispute}
          />
        </GenericModal>
      )}
    </>
  );
}

const RootWrapperModalMyreferralsfour = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  width: 100%;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
  width: 100%;
  padding: 0 16px;

  @media (max-width: 768px) {
    padding: 0 8px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
  width: 100%;
  max-width: 960px;

  @media (max-width: 768px) {
    border-radius: 16px;
    padding: 24px 16px;
  }

  @media (max-width: 480px) {
    padding: 20px 12px;
  }
`;

const Dispute = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 24px;
  border-radius: 32px;
  width: 100%;
  box-sizing: border-box;
  padding: 0px 16px;

  @media (max-width: 768px) {
    padding: 0px 8px;
    gap: 20px;
  }

  @media (max-width: 480px) {
    padding: 0px 4px;
    gap: 16px;
  }
`;

const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
  text-align: start;
`;

const Frame1504 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const OpenADispute = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const IfYouBelieveTheStatusOfYourReferralIsNotUpToDateOrInaccurateYouCanOpenADisputeOurTeamWillReviewAndGetBackToYouAsSoonAsPossible = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const Frame1422 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 12px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const Frame1505 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Frame1429 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const ReferralSummary = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const Frame1511 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

const Frame1510 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  box-sizing: border-box;
  min-width: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Frame1429_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
  min-width: fit-content;
`;

const ReferralUrl = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const JohnDoe = styled.span`
  color: rgb(33, 37, 67);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  min-width: 0;
  flex: 1;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const Vendor = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const XyzBusiness = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const SubmittedTo = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const _1Apr2025 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const RejectionReason = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const _4Apr2025 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const Frame1509 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const UnfortunatelyYourReferralWasNotSuccessfulThisTime = styled.span`
  color: rgb(33, 37, 67);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  overflow-wrap: break-word;
  word-break: break-word;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const Frame1514 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

const Frame1412 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  padding: 8px 0px;
  flex-shrink: 0;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 768px) {
    align-items: stretch;
  }
`;
